import React from "react";
import { useNavigate } from "react-router-dom";

const HomeVirtualTour = () => {
  const navigate = useNavigate();

  return (
    <section className="home-virtual-section">
      <div className="home-virtual-container">

        {/* LEFT CONTENT */}
        <div className="home-virtual-left">

          <span className="virtual-badge">
            Explore Campus Digitally
          </span>

          <h2 className="home-virtual-title">
            Virtual Tour Of School
          </h2>

          <p className="home-virtual-desc">
            Step inside our beautiful campus through an
            immersive 360° virtual experience. Explore
            classrooms, library, playground, activity
            zones and modern learning spaces from
            anywhere.
          </p>

          <p className="home-virtual-desc">
            Discover the environment where learning,
            creativity and growth happen every day.
            Parents and students can walk through the
            campus online before visiting physically.
          </p>

          <ul className="virtual-list">
            <li>360° Smart Campus Experience</li>
            <li>Explore Classrooms & Labs</li>
            <li>Library & Playground View</li>
            <li>Anytime, Anywhere Access</li>
          </ul>

          <button
            className="virtual-main-btn"
            onClick={() =>
              navigate("/virtual-tour")
            }
          >
            Start Virtual Tour
          </button>

        </div>

        {/* RIGHT SIDE CIRCLE */}
        <div className="home-virtual-right">

          <div
            className="virtual-circle"
            onClick={() =>
              navigate("/virtual-tour")
            }
          >
            <div className="circle-inner">

              <span className="circle-small">
                Click To
              </span>

              <span className="circle-big">
                ENTER
              </span>

              <span className="circle-small">
                Virtual Tour
              </span>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default HomeVirtualTour;